module.exports = __webpack_public_path__ + "static/media/home_cover.aecc875f.jpg";